import { createContext, useState } from 'react';
import api from 'services/api';

const filter = {};

export const RegraQualidadeContext = createContext();

export const RegraQualidadeProvider = ({ children }) => {
  const [getLoading, setGetLoading] = useState(false);
  const [regraQualidade, setRegraQualidade] = useState({
    data: [],
    colunas: [],
    filter,
    page: 0,
    size: 10,
  });

  const getRegraQualidade = async (payload) => {
    try {
      setGetLoading(true);
      const { data } = await api.post('/Grid', {
        filter: regraQualidade?.filter,
        page: regraQualidade?.page,
        size: regraQualidade?.size,
        order: regraQualidade?.order,
        ...payload,
      });
      setRegraQualidade((prev) => ({ ...prev, ...payload, ...data }));
    } catch (error) {
    } finally {
      setGetLoading(false);
    }
  };

  return (
    <RegraQualidadeContext.Provider
      value={{ getLoading, regraQualidade, getRegraQualidade }}
    >
      {children}
    </RegraQualidadeContext.Provider>
  );
};
